<div class="event-list-container">
  <nz-empty 
    *ngIf="events.length === 0" 
    [nzNotFoundContent]="'builderScreen.events.empty.noEvents' | translateTA"
    [nzNotFoundImage]="'simple'">
  </nz-empty>

  <div class="event-list" *ngIf="events.length > 0">
    <nz-card 
      *ngFor="let event of events"
      class="event-card"
      [class.event-disabled]="!event.enabled"
      nzSize="small">
      
      <div class="event-card-header">
        <div class="event-info">
          <nz-icon [nzType]="getEventTypeIcon(event.eventType)" nzTheme="outline"></nz-icon>
          <span class="event-type">{{ getEventTypeLabel(event.eventType) }}</span>
          <nz-tag [nzColor]="getModeColor(event.mode)">
            {{ event.mode === 'simple' ? ('builderScreen.events.mode.simple' | translateTA) : ('builderScreen.events.mode.expert' | translateTA) }}
          </nz-tag>
        </div>
        
        <div class="event-actions">
          <nz-switch 
            [(ngModel)]="event.enabled" 
            (ngModelChange)="onToggle(event)"
            nzSize="small"
            [nz-tooltip]="event.enabled ? ('builderScreen.events.tooltip.disable' | translateTA) : ('builderScreen.events.tooltip.enable' | translateTA)">
          </nz-switch>
        </div>
      </div>

      <div class="event-card-body">
        <p class="event-description">
          {{ event.description || ('builderScreen.events.description.noDescription' | translateTA) }}
        </p>

        <div class="event-details" *ngIf="event.mode === 'simple'">
          <nz-tag *ngIf="event.simpleConditions && event.simpleConditions.length > 0" nzColor="default">
            {{ event.simpleConditions.length }} {{ 'builderScreen.events.details.conditions' | translateTA }}
          </nz-tag>
          <nz-tag *ngIf="event.simpleActions && event.simpleActions.length > 0" nzColor="success">
            {{ event.simpleActions.length }} {{ 'builderScreen.events.details.actions' | translateTA }}
          </nz-tag>
        </div>

        <div class="event-details" *ngIf="event.mode === 'expert'">
          <nz-tag nzColor="orange">
            {{ 'builderScreen.events.details.customCode' | translateTA }}
          </nz-tag>
        </div>
      </div>

      <div class="event-card-footer">
        <button 
          nz-button 
          nzType="text" 
          nzSize="small"
          (click)="onEdit(event)"
          [nz-tooltip]="'builderScreen.events.tooltip.edit' | translateTA">
          <nz-icon nzType="edit" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.events.button.edit' | translateTA }}
        </button>

        <button 
          nz-button 
          nzType="text" 
          nzSize="small"
          (click)="onDuplicate(event)"
          [nz-tooltip]="'builderScreen.events.tooltip.duplicate' | translateTA">
          <nz-icon nzType="copy" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.events.button.duplicate' | translateTA }}
        </button>

        <button 
          nz-button 
          nzType="text" 
          nzDanger
          nzSize="small"
          (click)="onDelete(event)"
          [nz-tooltip]="'builderScreen.events.tooltip.delete' | translateTA">
          <nz-icon nzType="delete" nzTheme="outline"></nz-icon>
          {{ 'builderScreen.events.button.remove' | translateTA }}
        </button>
      </div>
    </nz-card>
  </div>
</div>



